import React from "react";
import { withRouter } from "react-router-dom";

const UnauthStartPage = ({ routerProps, startUI }) => {
    return (
        <div>
            {startUI}
        </div>
    );
};

export default withRouter(UnauthStartPage);